export const CAMPAIGN_STATUS = {
  DRAFT: 'draft',
  ACTIVE: 'active',
} as const;
